import { EventEmitter, Injectable, Output } from '@angular/core';
import { VehicleService } from 'src/app/vehicles/services/vehicle.service';

declare let L: any;
import 'leaflet-measure';
import 'leaflet-measure/dist/leaflet-measure.es';
import { MapService } from 'src/app/vehicles/services/map.service';
import 'leaflet-measure-path';
import 'leaflet-measure-path/leaflet-measure-path.css';
import { position } from 'html2canvas/dist/types/css/property-descriptors/position';
import { UnitTransmissionStatusService } from 'src/app/units/services/unit-transmission-status.service';
import { Unit } from 'src/app/units/models/unit';
import { map, tap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { PermissionService } from 'src/app/permiss/permission.service';

declare var $: any;
@Injectable({
  providedIn: 'root',
})
export class ToolbarMapService {
  map!: L.Map; //guardara el mapa
  toolbar: any;
  showDialog: boolean = false;

  showDistance: boolean = false;
  unitsTxStates: Subscription | undefined;
  circleUnitsTxStates: Subscription | undefined;

  measureControl = new L.control.measure({
    position: 'topright',
    primaryLengthUnit: 'kilometers',
    secondaryLengthUnit: 'feet',
    primaryAreaUnit: 'sqmeters',
    secondaryAreaUnit: 'hectares',
    localization: 'es',
    activeColor: 'blue',
    completedColor: '#9900ff',
    captureZIndex: 10000,
  });

  svgIcon = L.divIcon({
    html: this.geopointHTMLMarkerIcon('black'),
    className: '',
    iconSize: [24, 41.86],
    iconAnchor: [12, 41.86],
  });

  // btn4 = {
  //   marker : L.marker([0, 0],
  //     {
  //       icon: this.svgIcon ,
  //       // icon: L.icon({
  //       //   iconUrl: '/assets/images/realestate.png',
  //       //   iconAnchor: [16, 37],
  //       // }),
  //       draggable: true
  //     }),
  //   popup : L.popup( {offset: new L.Point(0, -25)}),
  //   visible : false, // visualizar el marcado al desaparece el popup
  //   cont : 1,
  // }
  btn5 = {
    marker: L.marker([0, 0], {
      icon: this.svgIcon,
      // icon: L.icon({
      //   iconUrl: '/assets/images/realestate.png',
      //   iconAnchor: [16, 37],
      // }),
      draggable: true,
    }),
    popup: L.popup({ offset: new L.Point(0, -25) }),
    tooltip: L.tooltip({
      permanent: true,
      offset: [0, -75],
      direction: 'center',
      className: 'text',
    }),
    visible: false,
  };

  container = L.DomUtil.create(
    'div',
    'leaflet-bar leaflet-control leaflet-control-custom'
  );

  @Output() change: EventEmitter<boolean> = new EventEmitter();
  @Output() changeCommandPanelVisibility: EventEmitter<boolean> =
    new EventEmitter();
  @Output() searchClick: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private mapService: MapService,
    private permissionService: PermissionService
  ) { }

  async createToolbar(map: L.Map) {
    this.map = map;
    console.log('toolbar render');

    const canSendCommand = await this.permissionService.hasPermission('vehicles_send_command_map');

    this.toolbar = {
      options: {
        position: 'topright',
      },
      onAdd: (map: any) => {
        this.createGroupAndUngroup();
        this.createLocation();
        this.createCoordinate();
        if (canSendCommand) {
          this.createCommandPanel();
        }
        this.createDistance();
        this.createSearchItems();
        this.createCenterLatLng();
        // this.createVehicleButton();
        return this.container;
      },
    };

    const toolbar = L.Control.extend(this.toolbar);
    return new toolbar();
  }

  createGroupAndUngroup() {
    var group = L.DomUtil.create('a', 'leaflet-link', this.container);

    // group.title = "Agrupar / Desagrupar";

    // var iGroup = L.DomUtil.create('i', 'fa fa-crosshairs', group);

    // coordinate.title = "Coordenadas";
    var iGroup = L.DomUtil.create('i', 'fa fa-crosshairs', group);
    var tooltip = L.DomUtil.create('p', 'custom-tooltip', group);
    tooltip.innerHTML = 'Agrupar / Desagrupar';

    tooltip.classList.add('tooltip-hidden');
    group.classList.add('tooltip-container');

    // Muestra el tooltip al pasar el mouse
    group.onmouseover = () => {
      tooltip.style.visibility = 'visible';
    };

    // Oculta el tooltip al quitar el mouse
    group.onmouseout = () => {
      tooltip.style.visibility = 'hidden';
    };

    group.onclick = () => {
      if (this.mapService.getClustering) {
        this.mapService.markerClusterGroup.disableClustering();
      } else {
        this.mapService.markerClusterGroup.enableClustering();
      }

      this.mapService.changeClusteringVisibility(
        !this.mapService.getClustering
      );
    };
  }
  createCommandPanel() {
    var commandPanel = L.DomUtil.create('a', 'leaflet-link', this.container);

    var iCommandPanel = L.DomUtil.create('i', 'fa fa-cog btn1', commandPanel);
    var tooltip = L.DomUtil.create('p', 'custom-tooltip', commandPanel);
    tooltip.innerHTML = 'Comandos';
    tooltip.classList.add('tooltip-hidden');
    commandPanel.classList.add('tooltip-container');

    // Muestra el tooltip al pasar el mouse
    commandPanel.onmouseover = () => {
      tooltip.style.visibility = 'visible';
    };

    // Oculta el tooltip al quitar el mouse
    commandPanel.onmouseout = () => {
      tooltip.style.visibility = 'hidden';
    };

    commandPanel.onclick = () => {
      // this.mapService.changeCommandPanelVisibility(
      //   !this.mapService.getCommandPanel,
      // );
      this.changeCommandPanelVisibility.emit(true);
    };
  }

  createLocation() {
    var location = L.DomUtil.create('a', 'leaflet-link', this.container);

    // location.title = "Mi ubicación";
    // var iLocation = L.DomUtil.create('i', 'fa fa-map-marker btn1', location);

    // coordinate.title = "Coordenadas";
    var ilocation = L.DomUtil.create('i', 'fa fa-map-marker btn1', location);
    var tooltip = L.DomUtil.create('p', 'custom-tooltip', location);
    tooltip.innerHTML = 'Mi ubicación';

    tooltip.classList.add('tooltip-hidden');
    location.classList.add('tooltip-container');

    // Muestra el tooltip al pasar el mouse
    location.onmouseover = () => {
      tooltip.style.visibility = 'visible';
    };

    // Oculta el tooltip al quitar el mouse
    location.onmouseout = () => {
      tooltip.style.visibility = 'hidden';
    };

    location.onclick = () => {
      var marker: any, circle: any, lat, long, accuracy;

      if (!navigator.geolocation) {
        console.log("Your browser doesn't support geolocation feature!");
      } else {
        navigator.geolocation.getCurrentPosition((position) => {
          lat = position.coords.latitude;
          long = position.coords.longitude;
          accuracy = position.coords.accuracy;

          marker = L.marker([lat, long], {
            icon: L.icon({
              iconUrl: '/assets/images/realestate.png',
              iconAnchor: [16, 37],
            }),
          });

          let popup = L.popup({ offset: new L.Point(0, -20) })
            .setLatLng([lat, long])
            .setContent(
              '<span>Usted está a ' +
                position.coords.accuracy +
                ' metros ala <br>redonda aproximadamente.</span>'
            )
            .addTo(this.map);

          circle = L.circle([lat, long], accuracy, {
            radius: accuracy,
            color: 'green',
            fillColor: 'green',
            fillOpacity: 0.1,
            opacity: 0.3,
            weight: 1,
          });

          var featureGroup = L.featureGroup([marker, circle]).addTo(this.map);

          popup.on('remove', () => {
            this.map.removeLayer(featureGroup);
          });

          this.map.setZoom(15);
          this.map.panTo([lat, long]);
        });
      }
    };
  }

  createCoordinate() {
    var coordinate = L.DomUtil.create('a', 'leaflet-link', this.container);

    // coordinate.title = "Coordenadas";
    var iCoordinate = L.DomUtil.create('i', 'fa fa-arrows', coordinate);
    var tooltip = L.DomUtil.create('p', 'custom-tooltip', coordinate);
    tooltip.innerHTML = 'Coordenadas';

    tooltip.classList.add('tooltip-hidden');
    coordinate.classList.add('tooltip-container');

    // Muestra el tooltip al pasar el mouse
    coordinate.onmouseover = () => {
      tooltip.style.visibility = 'visible';
    };

    // Oculta el tooltip al quitar el mouse
    coordinate.onmouseout = () => {
      tooltip.style.visibility = 'hidden';
    };

    coordinate.onclick = () => {
      //metodo
      this.change.emit(true);
    };
  }

  createSearchItems() {
    var coordinate = L.DomUtil.create('a', 'leaflet-link', this.container);

    // coordinate.title = "Búsqueda";
    var iCoordinate = L.DomUtil.create('i', 'fa fa-search', coordinate);
    var tooltip = L.DomUtil.create('p', 'custom-tooltip', coordinate);
    tooltip.innerHTML = 'Búsqueda';

    tooltip.classList.add('tooltip-hidden');
    coordinate.classList.add('tooltip-container');

    // Muestra el tooltip al pasar el mouse
    coordinate.onmouseover = () => {
      tooltip.style.visibility = 'visible';
    };

    // Oculta el tooltip al quitar el mouse
    coordinate.onmouseout = () => {
      tooltip.style.visibility = 'hidden';
    };

    coordinate.onclick = () => {
      this.searchClick.emit(true);
    };
  }

  createDistance() {
    // Crea el enlace
    var distance = L.DomUtil.create('a', 'leaflet-link', this.container);
    console.log('asd');

    var iDistance = L.DomUtil.create('i', 'fa fa-road', distance);
    var tooltip = L.DomUtil.create('p', 'custom-tooltip', distance);
    tooltip.innerHTML = 'Distancia'; //

    tooltip.classList.add('tooltip-hidden');
    distance.classList.add('tooltip-container');

    distance.onmouseover = () => {
      tooltip.style.visibility = 'visible';
    };

    // Oculta el tooltip al quitar el mouse
    distance.onmouseout = () => {
      tooltip.style.visibility = 'hidden';
    };

    ////////// en prueba
    // distance.onclick = () => {
    //   console.log("entrando a distancia");
    //   if (!this.showDistance) {
    //     this.measureControl.addTo(this.map);
    //     $('.leaflet-control-measure').css("max-width", "400px");
    //     this.showDistance = true;
    //     console.log("distancia", this.showDistance);

    //     this.map.on('measure:complete', (e: any) => {
    //       const { latlngs, distance } = e;
    //       console.log('Medición completa:', e); // Depuración

    //       if (latlngs.length === 2) {
    //         const distanceInMeters = latlngs[0].distanceTo(latlngs[1]);
    //         console.log(`Distancia calculada: ${distanceInMeters}`); // Depuración

    //         // Muestra la distancia en un popup
    //         L.popup()
    //           .setLatLng(latlngs[1])
    //           .setContent(`Distancia: ${distanceInMeters.toFixed(2)} metros`)
    //           .openOn(this.map);
    //       }
    //     });

    //   } else {
    distance.onclick = () => {
      if (this.showDistance == false) {
        this.measureControl.addTo(this.map);
        $('.leaflet-control-measure').css('max-width', '400px');
        this.showDistance = true;
      } else {
        this.map.removeControl(this.measureControl);
        this.showDistance = false;
      }
    };
  }

  // createCenterLatLng() {
  //   var CenterLatLng = L.DomUtil.create('a', 'leaflet-link', this.container);

  //   // CenterLatLng.title = "Latitud - Longitud";

  //   // var iCenterLatLng = L.DomUtil.create('i', 'fa fa-podcast', CenterLatLng);

  //   // coordinate.title = "Coordenadas";
  //   var iGroup = L.DomUtil.create('i', 'fa fa-podcast', CenterLatLng);
  //   var tooltip = L.DomUtil.create('p', 'custom-tooltip', CenterLatLng);
  //   tooltip.innerHTML = 'Latitud - Longitud';

  //   tooltip.classList.add('tooltip-hidden');
  //   CenterLatLng.classList.add('tooltip-container');

  //   // Muestra el tooltip al pasar el mouse
  //   CenterLatLng.onmouseover = () => {
  //     tooltip.style.visibility = 'visible';
  //   };

  //   // Oculta el tooltip al quitar el mouse
  //   CenterLatLng.onmouseout = () => {
  //     tooltip.style.visibility = 'hidden';
  //   };

  //   CenterLatLng.onclick = () => {
  //     if (this.btn5.visible) {
  //       console.log('====== click borrar');
  //       this.btn5.visible = false;
  //       this.map.removeLayer(this.btn5.tooltip);
  //       this.map.removeLayer(this.btn5.marker);
  //     } else {
  //       var centro = this.map.getCenter();
  //       var a = centro.lat;
  //       var b = centro.lng;
  //       var tbl =
  //         '<table><tr><td>Latitud</td><td>:</td><td> ' +
  //         centro.lat.toFixed(8) +
  //         '</td></tr><tr><td>Longitud</td><td>:</td><td> ' +
  //         centro.lng.toFixed(8) +
  //         '</td></tr></table>';

  //       this.map.removeLayer(this.btn5.marker);
  //       this.map.removeLayer(this.btn5.popup);

  //       this.btn5.marker.setLatLng([a, b]);
  //       this.btn5.marker.addTo(this.map);
  //       this.btn5.visible = true;

  //       // this.btn5.tooltip.setContent(tbl).setLatLng([a, b]).addTo(this.map);
  //     }
  //   };
  //   //==============================================

  //   this.btn5.marker.on('dragstart', () => {
  //     // console.log("====== dragstart");
  //     this.btn5.visible = false; // no ocultar el marcador
  //     // this.map.removeLayer(this.btn5.tooltip);
  //   });

  //   this.btn5.marker.on('dragend', (e: any) => {
  //     // console.log("====== dragend");
  //     var a = e.target._latlng.lat;
  //     var b = e.target._latlng.lng;
  //     this.btn5.visible = true;

  //     var tbl =
  //       '<table><tr><td>Latitud</td><td>:</td><td> ' +
  //       a.toFixed(8) +
  //       '</td></tr><tr><td>Longitud</td><td>:</td><td> ' +
  //       b.toFixed(8) +
  //       '</td></tr></table>';

  //     // this.btn5.tooltip.setContent(tbl);
  //     // this.btn5.tooltip.setLatLng([a, b]);
  //     // this.btn5.tooltip.addTo(this.map);
  //   });
  // }

  createCenterLatLng() {
    var CenterLatLng = L.DomUtil.create('a', 'leaflet-link', this.container);
    var iGroup = L.DomUtil.create('i', 'fa fa-podcast', CenterLatLng);
    var tooltip = L.DomUtil.create('p', 'custom-tooltip', CenterLatLng);
    tooltip.innerHTML = 'Latitud - Longitud';

    tooltip.classList.add('tooltip-hidden');
    CenterLatLng.classList.add('tooltip-container');

    CenterLatLng.onmouseover = () => {
      tooltip.style.visibility = 'visible';
    };
    CenterLatLng.onmouseout = () => {
      tooltip.style.visibility = 'hidden';
    };

    CenterLatLng.onclick = async () => {
      if (this.btn5.visible) {
        this.btn5.visible = false;
        this.map.removeLayer(this.btn5.marker);
      } else {
        var centro = this.map.getCenter();
        var a = centro.lat;
        var b = centro.lng;

        this.btn5.marker.setLatLng([a, b]);
        this.btn5.marker.addTo(this.map);
        this.btn5.visible = true;

        // Mostrar popup con botón copiar

        await new Promise((resolve) => setTimeout(resolve, 0));
        console.log('(TOOLBAR) Mostrando popup por primera vez');
        this.showLatLngPopup(a, b);
      }
    };

    // Evento: al hacer click en el marker, mostrar popup
    this.btn5.marker.on('click', async (e: any) => {
      const { lat, lng } = e.latlng || this.btn5.marker.getLatLng();
      console.log('(TOOLBAR) Mostrando popup por click');
      await new Promise((resolve) => setTimeout(resolve, 0));
      this.showLatLngPopup(lat, lng);
    });

    // Evento: al arrastrar el marker, actualizar popup
    this.btn5.marker.on('dragend', async (e: any) => {
      const { lat, lng } = e.target.getLatLng();
      console.log('(TOOLBAR) Mostrando popup por dragend');
      await new Promise((resolve) => setTimeout(resolve, 0));
      this.showLatLngPopup(lat, lng);
    });
  }

  /**
   * Muestra la lista de vehículos en un modal o popup flotante sobre el mapa
   * (Mantiene la función original sin modificaciones)
   */
  showVehicleList(units: Unit[], statusDescription: string) {
    let listContainer = document.getElementById('vehicle-info');
    if (!listContainer) {
      listContainer = document.createElement('div');
      listContainer.id = 'vehicle-info';
      listContainer.className = 'vehicle-info';
      document.body.appendChild(listContainer);
    }

    listContainer.innerHTML = `
  <div class="vehicle-list-header">
    <span><strong>${statusDescription}</strong></span>
    <button id="close-vehicle-list">X</button>
  </div>
  <ul>
    ${units
      .map(
        (unit) => `
      <li>
        <strong>${unit.unitName}</strong>
      </li>
    `
      )
      .join('')}
  </ul>
`;

    Object.assign(listContainer.style, {
      position: 'absolute',
      top: '50%',
      right: '50px',
      width: '200px',
      maxHeight: '250px',
      overflowY: 'auto',
      background: 'white',
      padding: '10px',
      borderRadius: '10px',
      boxShadow: '0px 4px 10px rgb(255, 255, 255)',
      zIndex: '1500',
      fontSize: '12px',
    });

    const styles = `
  .vehicle-info {
    padding: 0 !important;
  }
  .vehicle-list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 10px;
    background-color: #2F3B5C;
    color: white; 
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    font-size: 13px;
  }
  .vehicle-info ul {
    margin: 0;
    padding: 0 15px 15px 15px;
    list-style-position: inside;
  }
  .vehicle-info li {
    margin: 5px 0;
    color: #666; 
    font-weight: normal; 
    font-size: 12px;
  }
  #close-vehicle-list {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0 0 0 10px;
    font-size: 16px;
    color: white !important; 
    font-weight: bold; 
    opacity: 1;
  }
`;

    const styleSheet = document.createElement('style');
    styleSheet.textContent = styles;
    document.head.appendChild(styleSheet);

    document
      .getElementById('close-vehicle-list')
      ?.addEventListener('click', () => {
        listContainer?.remove();
        styleSheet.remove();
      });

    listContainer.classList.remove('hidden');
  }

  // Método para inicializar el componente
  // Ejemplo de cómo usar esta funcionalidad en el método de inicialización
  initialize() {
    // Código existente de inicialización del mapa
    // ...
    // Crear el botón de vehículos
    // const vehicleControls = this.createVehicleButton();
    // Ahora puedes acceder a los elementos si necesitas más configuración
    // vehicleControls.button - referencia al botón
    // vehicleControls.listContainer - referencia al contenedor de círculos
  }

  public geopointHTMLMarkerIcon(color: string) {
    return (
      `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 34.892"><g transform="matrix(1.18559 0 0 1.18559 -965.773 -331.784)"><path d="M817.112 282.971c-1.258 1.343-2.046 3.299-2.015 5.139.064 3.845 1.797 5.3 4.568 10.592.999 2.328 2.04 4.792 3.031 8.873.138.602.272 1.16.335 1.21.062.048.196-.513.334-1.115.99-4.081 2.033-6.543 3.031-8.871 2.771-5.292 4.504-6.748 4.568-10.592.031-1.84-.759-3.798-2.017-5.14-1.437-1.535-3.605-2.67-5.916-2.717-2.312-.048-4.481 1.087-5.919 2.621z" style="fill:` +
      color +
      `;"/><circle r="3.035" cy="288.253" cx="823.031" style="fill:#fff"/></g></svg>`
    );
  }
  // public iconoflecha(color: string) {
  //   return (
  //     `<svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
  //       <path d="M16 4L4 16H12V28H20V16H28L16 4Z" fill="black"/>
  //      </svg>`
  //   );
  // }

  showLatLngPopup(lat: number, lng: number) {
    // Cerrar cualquier popup existente antes de crear uno nuevo
    this.btn5.marker.closePopup();

    // Generar IDs únicos para evitar conflictos
    const timestamp = Date.now();
    const latContainerId = `lat-container-${timestamp}`;
    const latValueId = `lat-value-${timestamp}`;
    const lngContainerId = `lng-container-${timestamp}`;
    const lngValueId = `lng-value-${timestamp}`;

    const popup = `
      <div style="font-size: 13px; color: #222">
        <div style="display: flex; align-items: center;">
          <span style="font-weight: 500; min-width: 60px;">Latitud:</span>
          <div id="${latContainerId}" style="display: flex; align-items: center; gap: 6px; cursor: pointer; padding: 4px; border-radius: 4px; transition: background-color 0.2s;" onmouseover="this.style.backgroundColor='#f5f5f5'" onmouseout="this.style.backgroundColor='transparent'">
            <span id="${latValueId}" style="min-width: 100px; width: 100px; color: #000;">${lat.toFixed(
      8
    )}</span>
            <svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg>
          </div>
        </div>
        <div style="display: flex; align-items: center;">
          <span style="font-weight: 500; min-width: 60px;">Longitud:</span>
          <div id="${lngContainerId}" style="display: flex; align-items: center; gap: 6px; cursor: pointer; padding: 4px; border-radius: 4px; transition: background-color 0.2s;" onmouseover="this.style.backgroundColor='#f5f5f5'" onmouseout="this.style.backgroundColor='transparent'">
            <span id="${lngValueId}" style="min-width: 100px; width: 100px; color: #000;">${lng.toFixed(
      8
    )}</span>
            <svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg>
          </div>
        </div>
      </div>
    `;

    // Configurar popup con offset personalizado para posicionarlo más arriba
    const popupOptions = {
      offset: new L.Point(0, -40), // Mover el popup 40px hacia arriba
      closeButton: true,
      autoClose: false,
      autoPan: true,
    };

    // Usar setContent en lugar de bindPopup para actualizar el contenido sin crear nuevos popups
    if (!this.btn5.marker.getPopup()) {
      this.btn5.marker.bindPopup(popup, popupOptions);
    } else {
      this.btn5.marker.setPopupContent(popup);
    }

    this.btn5.marker.openPopup();

    // Usar un timeout más largo y buscar los elementos con los IDs únicos
    setTimeout(() => {
      // Configurar evento para copiar latitud
      const latContainer = document.getElementById(latContainerId);
      const latValue = document.getElementById(latValueId);
      let latCopying = false;

      if (latContainer && latValue) {
        // Remover cualquier evento anterior para evitar duplicados
        latContainer.onclick = null;

        latContainer.onclick = () => {
          if (latCopying) return; // Prevenir clics durante el estado "copiado"

          latCopying = true;
          const originalText = latValue.textContent;
          const textToCopy = lat.toFixed(8);

          navigator.clipboard
            .writeText(textToCopy)
            .then(() => {
              latValue.textContent = 'Copiado';
              latValue.style.color = '#000';
              latContainer.style.cursor = 'default';

              setTimeout(() => {
                latValue.textContent = originalText;
                latValue.style.color = '#000';
                latContainer.style.cursor = 'pointer';
                latCopying = false;
              }, 2000);
            })
            .catch(() => {
              // Fallback si clipboard API falla
              latValue.textContent = 'Error';
              latValue.style.color = '#ff0000';
              setTimeout(() => {
                latValue.textContent = originalText;
                latValue.style.color = '#000';
                latCopying = false;
              }, 2000);
            });
        };
      }

      // Configurar evento para copiar longitud
      const lngContainer = document.getElementById(lngContainerId);
      const lngValue = document.getElementById(lngValueId);
      let lngCopying = false;

      if (lngContainer && lngValue) {
        // Remover cualquier evento anterior para evitar duplicados
        lngContainer.onclick = null;

        lngContainer.onclick = () => {
          if (lngCopying) return; // Prevenir clics durante el estado "copiado"

          lngCopying = true;
          const originalText = lngValue.textContent;
          const textToCopy = lng.toFixed(8);

          navigator.clipboard
            .writeText(textToCopy)
            .then(() => {
              lngValue.textContent = 'Copiado';
              lngValue.style.color = '#000';
              lngContainer.style.cursor = 'default';

              setTimeout(() => {
                lngValue.textContent = originalText;
                lngValue.style.color = '#000';
                lngContainer.style.cursor = 'pointer';
                lngCopying = false;
              }, 2000);
            })
            .catch(() => {
              // Fallback si clipboard API falla
              lngValue.textContent = 'Error';
              lngValue.style.color = '#ff0000';
              setTimeout(() => {
                lngValue.textContent = originalText;
                lngValue.style.color = '#000';
                lngCopying = false;
              }, 2000);
            });
        };
      }
    }, 300);
  }
}
